<template>
	<form class="form" @submit.prevent="save" novalidate>
		<fieldset class="form__group">
			<legend>Confirm the information below</legend>

			<h2 class="h3">{{ resource.name }}</h2>
			<img v-if="resource.logo" :src="`/images/logo/${resource.id}`" alt="Logo" />

			<div class="post-details">
				<div v-if="resource.region" class="detail">
					<span class="label">Region covered</span>
				</div>
				<div v-if="resource.hq" class="detail">
					<span class="label">Company HQ Location</span>
					<span class="h3">
						<SvgIcon :icon="'location'" /> {{ resource.hq.location }}, {{ resource.hq.country.name }}
					</span>
				</div>
				<div v-if="resource.offices && resource.offices.length" class="detail">
					<span class="label">Additional company office location(s)</span>
					<span class="h3" v-for="office in resource.offices">
						<SvgIcon :icon="'location'" /> {{ office.location }}, {{ office.country.name }}
					</span>
				</div>
			</div>

			<div class="form__group form__group--submit">
				<button class="btn" @click.prevent="back" v-wait:disabled='["submit"]'>Back</button>
				<button class="btn btn--primary" v-wait:disabled='["submit"]'>Create Users</button>
			</div>
		</fieldset>
	</form>
</template>

<script>
	import API from './../../../api';
	import MemberFormStep from './MemberFormStep';
	import ResourcePreview from '../../ResourcePreview';
	import SvgIcon from '../../SvgIcon';

	export default {
		name: 'MemberFormStep3',
		components: {SvgIcon},
		mixins: [MemberFormStep, ResourcePreview],
		methods: {
			// fetchResource() {
			// 	return API.getMember(this.id);
			// }
		}
	}
</script>
